jQuery(document).ready(function($) {
  var Flickity = require('flickity-imagesloaded');
  require('flickity-as-nav-for');
  require('flickity-css');
});
